export { default as MenuTabla } from './MenuTabla';
export { default as TablaApoderadosPlanesDePago } from './TablaApoderadosPlanesDePago';



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/BuscarApoderado/componentes/index.ts